import { Environment } from 'constants/environment';

import { ENVIRONMENT_NAME } from 'config/entrypoint';

export const useEnvironment = () => {
  const environment = ENVIRONMENT_NAME as Environment;

  return {
    environment,
    isDevelopment: environment === Environment.Development,
    isSandbox: environment === Environment.Sandbox,
    isProduction: environment === Environment.Production,
  };
};
